import {
  systemAccountCollection,
  timeSlotCollection,
  carModelCollection,
  superPathCollection,
  adScheduleCollection,
  routeAveragesCollection,
} from "../../config/collectionsConfig";

export const GetTimeSlots = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_TIMESLOTS" });
      const firestore = getFirestore();
      firestore
        .collection(timeSlotCollection)
        .where("systemAccountId", "==", getState().profile.region.id)
        .orderBy("startTime", "asc")
        .get()
        .then((timeslotts) => {
          const timeslots = [];
          timeslotts.forEach((ts) => {
            timeslots.push({ ...ts.data(), id: ts.id });
          });
          dispatch({
            type: "GET_TIMESLOTS",
            payload: timeslots,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_TIMESLOTS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_TIMESLOTS_ERROR", payload: e });
    }
  };
};

export const GetTimeSlotsTest = (regionid) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_TIMESLOTS" });
      const firestore = getFirestore();
      firestore
        .collection(timeSlotCollection)
        .where("systemAccountId", "==", regionid)
        .orderBy("startTime", "asc")
        .get()
        .then((timeslotts) => {
          const timeslots = [];
          timeslotts.forEach((ts) => {
            timeslots.push({ ...ts.data(), id: ts.id });
          });
          dispatch({
            type: "GET_TIMESLOTS",
            payload: timeslots,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_TIMESLOTS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_TIMESLOTS_ERROR", payload: e });
    }
  };
};

export const GetDestinations = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_DESTINATIONS" });
      const firestore = getFirestore();
      firestore
        .collection(superPathCollection)
        .where("systemAccountId", "==", getState().profile.region.id)
        .orderBy("destination", "asc")
        .get()
        .then((dests) => {
          const destinations = [];
          dests.forEach((ds) => {
            destinations.push({ ...ds.data(), id: ds.id });
          });
          dispatch({
            type: "GET_DESTINATIONS",
            payload: destinations,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_DESTINATIONS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_DESTINATIONS_ERROR", payload: e });
    }
  };
};

export const GetDestinationsTest = (regionid) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_DESTINATIONS" });
      const firestore = getFirestore();
      firestore
        .collection(superPathCollection)
        .where("systemAccountId", "==", regionid)
        .orderBy("destination", "asc")
        .get()
        .then((dests) => {
          const destinations = [];
          dests.forEach((ds) => {
            destinations.push({ ...ds.data(), id: ds.id });
          });
          dispatch({
            type: "GET_DESTINATIONS",
            payload: destinations,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_DESTINATIONS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_DESTINATIONS_ERROR", payload: e });
    }
  };
};

export const GetCarModels = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_CARMODELS" });
      const firestore = getFirestore();
      firestore
        .collection(carModelCollection)
        .where("systemAccountId", "==", getState().profile.region.id)
        .orderBy("name", "asc")
        .get()
        .then((dests) => {
          const destinations = [];
          dests.forEach((ds) => {
            destinations.push({ ...ds.data(), id: ds.id });
          });
          dispatch({
            type: "GET_CARMODELS",
            payload: destinations,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_CARMODELS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_CARMODELS_ERROR", payload: e });
    }
  };
};

export const GetCarModelsTest = (regionid) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_CARMODELS" });
      const firestore = getFirestore();
      firestore
        .collection(carModelCollection)
        .where("systemAccountId", "==", regionid)
        .orderBy("name", "asc")
        .get()
        .then((dests) => {
          const destinations = [];
          dests.forEach((ds) => {
            destinations.push({ ...ds.data(), id: ds.id });
          });
          dispatch({
            type: "GET_CARMODELS",
            payload: destinations,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_CARMODELS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_CARMODELS_ERROR", payload: e });
    }
  };
};

export const GetRegionsForBusiness = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch(StartLoadingProfile());
      const firestore = getFirestore();
      firestore
        .collection(systemAccountCollection)
        .where("businessStatus", "==", true)
        .where("disabled", "==", false)
        .orderBy("regionName", "asc")
        .get()
        .then((regions) => {
          const regionslist = [];
          regions.forEach((ds) => {
            regionslist.push({
              name: ds.data().regionName,
              id: ds.id,
              extraStartDays: ds.data().extraStartDays,
              roughEstimate: ds.data().roughEstimate,
              adBrakeMaximumLength: ds.data().adBrakeMaximumLength,
              maximumFreqPerRoute: ds.data().maximumFreqPerRoute,
              minimumFreqPerRoute: ds.data().minimumFreqPerRoute,
              minimumBudget: ds.data().minimumBudget,
              scheduleRestriction: ds.data().scheduleRestriction,
            });
          });
          console.log("regions");
          console.log(regionslist);

          dispatch({
            type: "GET_REGIONS_FOR_BUSINESS",
            payload: regionslist,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_REGIONS_FOR_BUSINESS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_REGIONS_FOR_BUSINESS_ERROR", payload: e });
    }
  };
};

export const GetRegionsForVehicles = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch(StartLoadingProfile());
      const firestore = getFirestore();
      firestore
        .collection(systemAccountCollection)
        .where("vehicleStatus", "==", true)
        .orderBy("regionName", "asc")
        .get()
        .then((regions) => {
          //console.log(regions);
          const regionslist = [];
          regions.forEach((ds) => {
            regionslist.push({
              name: ds.data().regionName,
              id: ds.id,
              phone: ds.data().phoneNumber,
            });
          });

          dispatch({
            type: "GET_REGIONS_FOR_VEHICLE",
            payload: regionslist,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_REGIONS_FOR_VEHICLE_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_REGIONS_FOR_VEHICLE_ERROR", payload: e });
    }
  };
};

export const GetAdSchedules = (regionid, extraStartDays, roughEstimate) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch(StartLoadingAdSchedule());
      const firestore = getFirestore();
      firestore
        .collection(adScheduleCollection)
        .where("systemAccountId", "==", regionid)
        .get()
        .then((schedules) => {
          //console.log(regions);
          const schlist = [];
          schedules.forEach((ds) => {
            schlist.push({
              id: ds.id,
              ...ds.data(),
            });
          });

          dispatch({
            type: "GET_AD_SCHEDULES",
            payload: {
              adSchedules: schlist,
              extraStartDays: extraStartDays,
              roughEstimate: roughEstimate,
            },
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_AD_SCHEDULES_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_AD_SCHEDULES_ERROR", payload: e });
    }
  };
};

export const GetRouteAverages = (regionid) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch(StartLoadingRouteAverages());
      const firestore = getFirestore();
      firestore
        .collection(routeAveragesCollection)
        .where("systemAccountId", "==", regionid)
        .get()
        .then((routes) => {
          //console.log(regions);
          const ralist = [];
          routes.forEach((ds) => {
            ralist.push({
              id: ds.id,
              ...ds.data(),
            });
          });

          dispatch({
            type: "GET_ROUTE_AVERAGES",
            payload: ralist,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_ROUTE_AVERAGES_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_ROUTE_AVERAGES_ERROR", payload: e });
    }
  };
};

export const StartLoadingProfile = () => {
  return {
    type: "LOADING_REGIONS",
  };
};

export const StartLoadingRouteAverages = () => {
  return {
    type: "LOADING_ROUTEAVERAGE",
  };
};

export const StartLoadingAdSchedule = () => {
  return {
    type: "LOADING_ADSCHEDULE",
  };
};
